module.exports = __webpack_public_path__ + "static/media/detail-before.17a47043.png";